<template>
  <footer class="footer pv5-ns pv4 pl6-ns pl5 f3-ns f5 flex flex-column">
    <div class="link mb4-ns mb3"> – </div>
    <div class="mb4-ns mb3"> <a class="link" href="/"> Contact </a> </div>
    <div class="mb4-ns mb3"> <a class="link" href="/"> Instagram </a> </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
  .footer {
    background: #f1ece6
  }
</style>
